<template>
  <AppTransition>
    <header
      class="h-12 w-full z-100 relative px-4 flex items-center bg-white shadow"
    >
      <span class="font-black uppercase type-scale-n3 mr-8">traindplan</span>
      <template v-for="(tab, $i) in tabs">
        <AppTab
          @click="$router.push(tab.path)"
          :active="tab.active"
          :key="$i"
          >{{ tab.name }}</AppTab
        >
      </template>
    </header>
  </AppTransition>
</template>

<script>
import AppTab from './AppTab'

export default {
  name: 'AppBar',

  components: {
    AppTab
  },

  computed: {
    tabs() {
      return [
        {
          name: 'Tidtabell',
          path: '/timetable',
          active: this.$route.path.includes('timetable')
        },
        {
          name: 'Trafikplatser',
          path: '/traffic-locations',
          active: this.$route.path.includes('traffic-locations')
        }
      ]
    }
  }
}
</script>
